<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="search-data">
  <h5 id="tbl-pageTop">Search data by filter</h5>
  <div class="create-booking">
    <ul>
      <li>
        <div class="booking-inner" (click)="exportData()" >
          <img src="../../../../assets/images/export-list.svg" alt="Export list"/>
          <span>Export</span>
        </div>
      </li>
    </ul>
  </div>
</div>
<form [formGroup]="creditListForm">
  <div class="date-filter">

    <div class="grid">
      <div class="col-12 lg:col-2">
        <div class="date-outer">
          <label for="name">Name</label>
          <div class="custom-select2">
            <div class="filter-parking header-filter">
              <input id="name" type="text" pInputText placeholder="Enter Name" formControlName="name" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 lg:col-2">
        <div class="date-outer">
          <label for="email">Email</label>
          <div class="custom-select2">
            <div class="filter-parking header-filter">
              <input id="email" type="text" pInputText placeholder="Enter Email" formControlName="email" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 lg:col-2">
        <div class="date-outer">
          <label for="number">Number</label>
          <div class="custom-select2">
            <div class="filter-parking header-filter">
              <input id="number" type="text" pInputText placeholder="Enter Mobile Number" formControlName="number"
                (keypress)="onlyNumber($event)" />
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isSuperAdmin()" class="col-12 lg:col-2">
        <div class="date-outer">
            <label for="companies">Company<span class="custom-star">*</span></label>
            <div class="custom-select2">
                <div class="filter-parking header-filter financials-filter">
                    <p-multiSelect id="companies" [options]="companyList" formControlName="companies" optionLabel="name"
                        [defaultLabel]="'Select Companies'" (onChange)="onSelectionChange($event)"
                        [autoZIndex]="true">
                    </p-multiSelect>
                    <img src="assets/images/fill-dropdown.svg" alt=""/>
                </div>
            </div>
        </div>
        <div *ngIf="showAsterisk" class="validation-error">This field is required*</div>
    </div>
      <div class="col-12 lg:col-2">
        <div class="date-outer">
          <label for="userType">User Type</label>
          <div class="custom-select2">
            <div class="filter-parking header-filter">
              <p-dropdown id="userType" [options]="userTypeDropdown"
                placeholder="Select Status" formControlName="userType" optionLabel="name" optionValue="value"
                optionValue="value"></p-dropdown>
              <img src="assets/images/fill-dropdown.svg" alt=""/>
            </div>
          </div>
        </div>
      </div>
    
      <div *ngIf="!isSuperAdmin()" class="col-12 lg:col-2">
        <div class="date-outer">
          <label for="givenBy">Credit Given By</label>
          <div class="custom-select2">
            <div class="filter-parking header-filter">
              <p-dropdown id="givenBy" [options]="selectStatus"
                placeholder="Select Status" formControlName="givenBy" optionLabel="name" optionValue="id"
                optionValue="value"></p-dropdown>
              <img src="assets/images/fill-dropdown.svg" alt=""/>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-1">
        <div class="date-outer-btn">
          <div class="edit-outer">
            <p-button styleClass="p-button search-button" label="Apply Filter"
              (onClick)="getUserListCreatedBySuperAdmin('search')"></p-button>

          </div>
        </div>
      </div>
      <div class="col-12 lg:col-1">
        <div class="date-outer-btn">
          <div class="edit-outer reset-btn">
            <p-button styleClass="p-button  p-button-outlined" label="Reset" (onClick)="resetFilter()"></p-button>

          </div>  
        </div>
      </div>
      <div class="hide-advance" *ngIf="isSuperAdmin()">
        <h5 *ngIf="hideAdvanceFilter" (click)="toggleHideAdvanceFilter()">Hide Advanced Filter</h5>
        <h5 *ngIf="!hideAdvanceFilter" (click)="toggleHideAdvanceFilter()">Advanced Filter</h5>
      </div>
   
    <div *ngIf="isSuperAdmin && hideAdvanceFilter" class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="givenBy">Credit Given By</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <p-dropdown id="givenBy" [options]="selectStatus"
              placeholder="Select Status" formControlName="givenBy" optionLabel="name" optionValue="id"
              optionValue="value"></p-dropdown>
            <img src="assets/images/fill-dropdown.svg" alt=""/>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div class="driver-list-outer">
    <div class="list-heading">
      <h4>Custom Credit List</h4>
      <div class="page-list filter-parking">
        <p>Show
          <p-dropdown [options]="CustomItemPerPageBy" (onChange)="onDropdownChange($event,'dropdownchange')"
            placeholder="10" optionLabel="name" optionValue="value" ></p-dropdown><img
            src="assets/images/fill-dropdown.svg" alt=""/>
          Records
        </p>
      </div>
    </div>
    <div class="card parking-list" [class.parking-list]="creditList?.length>0">

      <p-table id="tbl-top" [value]="creditList" [resizableColumns]="true" columnResizeMode="expand" tableLayout="fixed">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col">Name</th>
            <th scope="col" class="custom-addres">Email</th>
            <th scope="col">Mobile Number</th>
            <th scope="col">User Type</th>
            <th scope="col">Company Name</th>
            <th scope="col">Credit Given By </th>
            <th scope="col">Credit Given Date </th>
            <th scope="col">Credits</th>
            <th scope="col">Reason</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr class="border12">
            <td class="cursor-pointer" (click)="goToCrmPage(rowData)">
              <div class="driver-names"><img
                  [src]="(rowData.profileImagePath)?rowData.profileImagePath:dummy" alt=""/><span>{{rowData.driverName || '-' }}</span></div>
            </td>
            <td>
              <div class="driver-email">{{rowData.email || '-'}}</div>
            </td>
            <td>
              <div class="mobile-number"><span *ngIf="rowData?.phoneNumber"
                  [ngClass]="getFlagClass(rowData?.iso)"></span>{{ rowData.countryCode &&
                rowData.phoneNumber ? (rowData.countryCode + ' ' + rowData.phoneNumber) : '-' }}</div>
            </td>
            <td>{{ rowData.userType}}</td>
            <td>{{rowData.companyName}}</td>
            <td>
            {{rowData.creditGivenByRole}}-{{rowData.creditGivenByName}}
            </td>
            <td>{{ rowData.creditGivenDate | customDate1}}</td>
            <td>
             {{ rowData.creditAmount}}
            </td>
            <td class="reason-column">
              <div class="last-reason"><p>{{rowData.reason}}</p></div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr class="no-border">
            <td class="no-record" colspan="9">
              No Record Found
            </td>
          </tr>
        </ng-template>

      </p-table>

      <div class="card flex justify-content-end custom-pagination2" *ngIf="creditList?.length > 0">
        <p-paginator [first]="currentSkip" [rows]="itemsPerPage" [totalRecords]="totalUserRecord"
          (onPageChange)="onPageChange($event)"></p-paginator>
      </div>
    </div>
  </div>
</form>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>